
export const billingMethodSchema = {
    name: '{ type:"input", rules:"required"}',
    description: '{ type:"textarea", rules:"required"}',
    type: '{ type:"select", rules:"required", items:["manual"]}',
    method: '{ type:"select", rules:"required", items:["firstday","lastday","float","daily"]}',
    interval: '{ type:"input", rules:"required|numeric|min_value^:0", inputType:"number" }',
    default: '{type:"switch"}',
}